'use client';

import type { ReactNode } from 'react';
import { ConsentProvider } from './ConsentProvider';
import CookieBanner from './CookieBanner';
import CookiePreferences from './CookiePreferences';

export default function ConsentRoot({ children }: { children: ReactNode }) {
  return (
    <ConsentProvider>
      {children}
      <CookieBanner />
      <CookiePreferences />
    </ConsentProvider>
  );
}
